import React from 'react';

import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LightChip } from '@uplift/ui-v2';


export type DocumentListItemStatusColor = 'error' | 'warning' | 'success' | 'neutral';


const chipColors: Record<DocumentListItemStatusColor, 'error' | 'warning' | 'success' | 'lightGrey'> = {
  error: 'error',
  warning: 'warning',
  success: 'success',
  neutral: 'lightGrey',
};


const useStyles = makeStyles<{ statusColor: DocumentListItemStatusColor }>({ name: 'DocumentListItemRow' })((theme, { statusColor }) => ({
  root: {
    alignItems: 'center',
    borderLeft: '3px solid',
    borderLeftColor: statusColor === 'neutral' ? 'transparent' : theme.palette[statusColor].main,

    '&.Mui-selected': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  icon: {
    minWidth: 36,
    color: statusColor === 'neutral' ? theme.palette.text.disabled : theme.palette[statusColor].main,
  },
}));


export const DocumentListItemRow: React.VFC<{
  name: string;
  status: string;
  statusColor: DocumentListItemStatusColor;
  icon: React.ReactNode;
  onClick: () => void;
  selected: boolean;
}> = ({ name, status, statusColor, icon, onClick, selected }) => {
  const { classes } = useStyles({ statusColor });

  return (
    <ListItemButton onClick={onClick} selected={selected} className={classes.root}>
      <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
      <ListItemText
        primary={name}
        secondary={<LightChip size="small" color={chipColors[statusColor]} label={status} />}
        slotProps={{
          primary: { noWrap: true },
          secondary: { component: 'div' },
        }}
      />
    </ListItemButton>
  );
};
